import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import themeable from 'zignal-landscape/lib/themeable';

import DownloadMenu from '../../../../components/DownloadMenu';
import * as actions from '../../BotIntelligence.ducks';
import {
  filterAuthorNodesOnly,
  getAuthorsAndStoriesToExport,
} from '../../dataUtils';

const mapStateToProps = (
  (state) => ({
    showSelectionOnly: state.BotIntelligence.Page.showSelectionOnly,
    authorNodes: state.BotIntelligence.Page.authorNodes,
    filteredAutomationScore: state.BotIntelligence.Page.filteredAutomationScore,
    selectedTopClustersByVolume: state.BotIntelligence.Page.selectedTopClustersByVolume,
    isLoading: state.BotIntelligence.Page.isLoading,
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class GraphDataExport extends React.Component {
  constructor(props) {
    super(props);

    this.getFilteredAuthorNodes = this.getFilteredAuthorNodes.bind(this);
    this.generateAuthorsAndStoriesToExport = this.generateAuthorsAndStoriesToExport.bind(this);
  }

  getFilteredAuthorNodes() {
    const {
      clusterNodes,
      showSelectionOnly,
      authorNodes,
      filteredAutomationScore,
      selectedTopClustersByVolume
    } = this.props;

    const selectedClusters = showSelectionOnly ? selectedTopClustersByVolume : [];
    return filterAuthorNodesOnly({
      authorNodes,
      clusterNodes,
      filteredAutomationScore,
      selectedClusters
    });
  }

  generateAuthorsAndStoriesToExport() {
    const filteredNodes = this.getFilteredAuthorNodes();
    return getAuthorsAndStoriesToExport(filteredNodes);
  }

  render() {
    const {
      styles,
      authorNodes,
      isLoading,
    } = this.props;

    if (isLoading || !authorNodes.length) {
      return null;
    }

    const timestamp = moment().format('X');
    const fileName = `influence_intelligence_export_${timestamp}`;

    return (
      <div className={styles.GraphDataExport}>
        <DownloadMenu
          getAuthorsAndStories={this.generateAuthorsAndStoriesToExport}
          fileNameWithoutExtension={fileName}
          exportFileName="Authors - "
        />
      </div>
    );
  }
}

GraphDataExport.propTypes = {
  styles: PropTypes.object.isRequired,
  clusterNodes: PropTypes.array,
  // state
  showSelectionOnly: PropTypes.bool.isRequired,
  authorNodes: PropTypes.arrayOf(PropTypes.object).isRequired,
  filteredAutomationScore: PropTypes.object.isRequired,
  selectedTopClustersByVolume: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(GraphDataExport));
